import LoginForm from "../../ui/login-form";

const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;